export class CollaboratorFilter {
    public query = '';
    public name = '';
    public document = '';
    public register = '';
    public costCenter: number[] = [];
    public unit: number[] = [];
    public departament: number[] = [];
    public orderby: string = '';
    public ordertype: boolean;
    public situation: string;
    public products: string[] = [];
    public withoutGroup: boolean = false;
    public type: number = null;
    //public hasApp =null;
}
